import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import groupBy from 'utils/groupBy';
/**
 * Checks whether the passed-in items follow our
 * playlist content structure rules.
 *
 * Each section/depth level is checked individually.
 */

export function checkIsValidPlaylistContentState(_ref) {
  var content = _ref.content,
    parentId = _ref.parentId,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 0 : _ref$level;
  var contentAtThisLevel = content.filter(function (item) {
    return item.parent_id === parentId;
  });

  // Split items at this level into sections and content
  var _groupBy = groupBy(contentAtThisLevel, function (item) {
      return item.type === 'section' ? 'sections' : 'contentItems';
    }),
    _groupBy$sections = _groupBy.sections,
    sections = _groupBy$sections === void 0 ? [] : _groupBy$sections,
    _groupBy$contentItems = _groupBy.contentItems,
    contentItems = _groupBy$contentItems === void 0 ? [] : _groupBy$contentItems;
  var hasSections = sections.length > 0;
  var hasContent = contentItems.length > 0;

  // RULE 1: Subsections can't have more subsections:
  if (level > 1 && hasSections) {
    return false;
  }

  // RULE 2: Assets can only appear before sections, i.e.
  // not have a higher rank than sections
  var isMixedLevel = hasSections && hasContent;
  if (isMixedLevel) {
    var lowestSectionLocalRank = sections.reduce(function (lowestRank, _ref2) {
      var rank = _ref2.rankInSection;
      return rank < lowestRank ? rank : lowestRank;
    }, Infinity);
    if (contentItems.some(function (item) {
      return item.rankInSection >= lowestSectionLocalRank;
    })) {
      return false;
    }
  }

  // RULE 3: All nested sections must be valid, too:
  if (hasSections) {
    return sections.every(function (section) {
      return checkIsValidPlaylistContentState({
        content: content,
        parentId: section.id,
        level: level + 1
      });
    });
  } else {
    return true;
  }
}